import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Payment, DateRange } from '../../entity';
import { PaginationService, SettingsService, PaymentsService } from '../../service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { SelectItem, LazyLoadEvent, FilterMetadata, DialogService } from 'primeng/api';
import { SearchPaymentsQuery, SearchPaymentsResponse, SearchFilter } from '../../entity/other-entities/search-payments-query';
import Enums from '../../utils/enums';

import * as FileSaver from 'file-saver';
import { DatePipe } from '@angular/common';
import { Subject, of } from 'rxjs';
import { takeUntil, tap, debounceTime, switchMap, catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from '../../service/common/toastr.service';

import { CheckPlateComponent } from '../check-plate/check-plate.component';
import { Calendar } from 'primeng/calendar';

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    providers: [DialogService]
})
export class PaymentsComponent implements OnInit, OnDestroy {

    protected refreshEvent: Subject<SearchPaymentsQuery> = new Subject();
    protected ngUnsubscribe: Subject<void> = new Subject<void>();

    payments: Array<Payment> = new Array<Payment>();
    filteredList: Array<Payment> = new Array<Payment>();

    //#region date picker properties
    // initialPickerDate: Date[];
    // bsConfig: Partial<BsDaterangepickerConfig> = {
    //     rangeInputFormat: 'DD/MM/YYYY',
    //     showWeekNumbers: false
    // };

    @ViewChild('rangeCalendar') rangeCalendar: Calendar;
    rangeDates: Date[];
    isFirstSelected = false;
    dateRange: DateRange = new DateRange();
    //#endregion

    //#region component state properties
    loadingState = false;
    noRecordsState = true;
    downloadingState = false;
    //#endregion

    //#region primeng
    cols: any[];
    //dateRange: DateRange;
    paymentMethods: SelectItem[];
    filters: SearchFilter[];

    firstRow = 0;
    totalRecords = 0;
    //#endregion

    constructor(
        private paymentsService: PaymentsService,
        private settingsService: SettingsService,
        private datePipe: DatePipe,
        private toastService: ToastrService,
        public dialogService: DialogService
    ) {
    }

    ngOnInit() {
        this.cols = [
            { field: 'FullName', header: 'Nume', sortField: null },
            { field: 'Phone', header: 'Telefon', sortField: null },
            { field: 'Plate', header: 'Masina', sortField: null },
            { field: 'PaymentMethod', header: 'Tip plata', sortField: null },
            { field: 'DisplayAmount', header: 'Cost', sortField: null },
            { field: 'ParkingTitle', header: 'Zona', sortField: null },
            { field: 'Date', header: 'Data', sortField: 'Date' },
            { field: 'Interval', header: 'Inverval', sortField: null }
        ];

        this.paymentMethods = [
            { label: 'Toate', value: null },
            { label: 'SMS', value: Enums.ePaymentMethodType.SMS },
            { label: 'Card', value: Enums.ePaymentMethodType.Card }
        ];

        this.onDateRangeChanged([new Date(), new Date()]);

        this.refreshEvent
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(tap((query: SearchPaymentsQuery) => {
                this.loadingState = true;
                this.noRecordsState = false;
                const returnTotalCount = query.Skip === 0;
                query.ReturnTotalCount = returnTotalCount;
                console.log(query);
            }))
            .pipe(debounceTime(250))
            .pipe(switchMap((query) => {
                return this.paymentsService.getPayments(query)
                    .pipe(catchError(err => of({ httpError: err })))
                    .pipe(map(x => ({ result: x, query: query })));
            }))
            .subscribe(
                (result) => {
                    this.loadingState = false;
                    const errorResponse = (<{ httpError: HttpErrorResponse }>result.result).httpError;
                    if (errorResponse) {
                        this.toastService.error(`Error loading payments data: ${errorResponse.statusText}`);
                        return;
                    }

                    const response = result.result;
                    const query = result.query;
                    const searchResponse = new SearchPaymentsResponse();
                    searchResponse.fromObject(response);
                    const data = searchResponse.Items || [];
                    const payments = new Array<Payment>();
                    data.forEach(item => {
                        const payment = new Payment();
                        payment.fromObject(item);

                        payment.PaymentIcon = this.settingsService.PAYMENT_METHOD_TYPE_ICON(payment.PaymentMethodTypeID);
                        payment.PaymentMethod = this.settingsService.PAYMENT_METHOD_TYPE(payment.PaymentMethodTypeID);
                        payment.Currency = this.settingsService.CURRENCY_TYPES(payment.CurrencyID);

                        payment.DisplayAmount = `${payment.Amount} ${payment.Currency}`;

                        payments.push(payment);
                    });
                    this.payments = payments;

                    if (this.payments.length > 0) {
                        this.noRecordsState = false;
                    } else {
                        this.noRecordsState = true;
                    }

                    this.firstRow = query.Skip || 0;
                    console.log(query);
                    if (query.ReturnTotalCount) {
                        this.totalRecords = searchResponse.TotalCount;
                    }
                }
            );
            this.refresh();

    }

    refresh(): void {
        if (this.dateRange) {
            const { StartDate, EndDate } = this.dateRange;
            var endDate = new Date( this.dateRange.EndDate);
            var startDate = new Date(this.dateRange.StartDate);
            startDate.setUTCHours(0);
            endDate.setUTCHours(23);
            endDate.setUTCMinutes(59);
            endDate.setUTCSeconds(59);
            const query = new SearchPaymentsQuery(startDate, endDate);
            this.fillFilters(query, 0, 20);
            this.raiseLoadItemsEvent(query);
            this.rangeDates = [StartDate, EndDate];
        } else {
            const query = new SearchPaymentsQuery(new Date(), new Date());
            this.fillFilters(query, 0, 20);
            this.raiseLoadItemsEvent(query);
            let dateNext = new Date();
            dateNext.setDate(dateNext.getDate() + 1);
            this.rangeDates = [new Date(), dateNext];
        }
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    private raiseLoadItemsEvent(query: SearchPaymentsQuery) {
        this.refreshEvent.next(query);
    }

    //#region Date picker methods
    //#region calendar methods
    selectDates(date: Date): void {
        
        date.setHours(3);
        if (!this.isFirstSelected) {
            this.dateRange.StartDate = date;
            this.isFirstSelected = true;
        } else {
            this.dateRange.EndDate = date;
            this.isFirstSelected = false;
            var endDate = new Date( this.dateRange.EndDate);
            endDate.setUTCHours(23);
            endDate.setUTCMinutes(59);
            endDate.setUTCSeconds(59);
            var startDate = new Date(this.dateRange.StartDate);
            startDate.setUTCHours(0);
            const query = new SearchPaymentsQuery(startDate, endDate);
            this.fillFilters(query, 0, 20);
            this.raiseLoadItemsEvent(query);
            this.rangeCalendar.overlayVisible = false;
        }
    }

    onDateRangeChanged(event: Date[]) {
        const dateRange = new DateRange(
            event[0],
            event[1],
        );

        this.dateRange = dateRange;
        var startdate = dateRange.StartDate;
        var enddate = dateRange.EndDate;
        const query = new SearchPaymentsQuery(startdate, enddate);
        this.fillFilters(query, 0, 20);
        this.raiseLoadItemsEvent(query);
    }

    private fillFilters(query: SearchPaymentsQuery, skip: number, take: number) {
        query.Skip = skip;
        query.Take = take;
        query.Filters = [];

        if (this.filters) {
            for (const filter of this.filters) {
                query.Filters.push(filter);
            }
        }
    }

    loadData(event: LazyLoadEvent) {
        // event.first = First row offset
        // event.rows = Number of rows per page
        // event.sortField = Field name to sort in single sort mode
        // event.sortOrder = Sort order as number, 1 for asc and -1 for dec in single sort mode
        // multiSortMeta: An array of SortMeta objects used in multiple columns sorting. Each SortMeta has field and order properties.
        // filters: Filters object having field as key and filter value, filter matchMode as value
        // globalFilter: Value of the global filter if available
        var endDate = new Date( this.dateRange.EndDate);
        endDate.setUTCHours(23);
        endDate.setUTCMinutes(59);
        endDate.setUTCSeconds(59);
        var startDate = new Date(this.dateRange.StartDate);
        startDate.setUTCHours(0);
        const query = new SearchPaymentsQuery(startDate, endDate);
        query.Skip = 0;
        query.Take = 20;
        if (event.sortField) {
            query.OrderBy = event.sortField;
            query.OrderDesc = event.sortOrder < 0;
        }
        query.Filters = [];
        if (event.filters) {
            // tslint:disable-next-line: forin
            for (const filterKey in event.filters) {
                const filter = event.filters[filterKey];
                if (!filter) {
                    continue;
                }
                if (filterKey !== 'PaymentMethod') {
                    query.Filters.push(new SearchFilter(filterKey, filter.value));
                } else {
                    const searchFilter = new SearchFilter(filterKey, null);
                    searchFilter.IntValue = filter.value;
                    query.Filters.push(searchFilter);
                }
            }
        }
        this.filters = query.Filters;
        // console.log(event);
        this.raiseLoadItemsEvent(query);
    }

    paginate(event) {
        if (this.loadingState) {
            return;
        }
        // event.first = Index of the first record
        // event.rows = Number of rows to display in new page
        // event.page = Index of the new page
        // event.pageCount = Total number of pages

        var endDate = new Date( this.dateRange.EndDate);
        endDate.setUTCHours(23);
        endDate.setUTCMinutes(59);
        endDate.setUTCSeconds(59);
        var startDate = new Date(this.dateRange.StartDate);
        startDate.setUTCHours(0);
        const query = new SearchPaymentsQuery(startDate, endDate);
        this.fillFilters(query, event.first, event.rows);
        this.raiseLoadItemsEvent(query);
    }


    download() {
        if (this.downloadingState) {
            return;
        }
        this.downloadingState = true;
        var endDate = new Date(this.dateRange.EndDate);
        endDate.setUTCHours(23);
        endDate.setUTCMinutes(59);
        endDate.setUTCSeconds(59);
        var startDate = new Date(this.dateRange.StartDate);
        startDate.setUTCHours(0);
        const query = new SearchPaymentsQuery(startDate, endDate);
        this.fillFilters(query, null, null);
        this.paymentsService.exportPayments(query)
            .subscribe(
                (data) => {
                    this.downloadingState = false;
                    const startPart = this.datePipe.transform(query.StartDate, 'dd-MM-yyyy');
                    const endPart = this.datePipe.transform(this.dateRange.EndDate, 'dd-MM-yyyy');
                    FileSaver.saveAs(data, `Plati ${startPart} - ${endPart}.csv`);
                },
                (error) => {
                    this.downloadingState = false;
                    console.error(error);
                }
            );
    }

    //#endregion

    onCheckClicked(): void {
        this.dialogService.open(
            CheckPlateComponent,
            {
                header: 'Verifica numar',
                width: '70%'
            }
        );
    }
}
